import React, { Component } from 'react';
import InternalContainer from '../../layout/containers/Internal';
import ChannelsTable from '../components/ChannelsTable';
import { connect } from 'react-redux';
import { actions as channelActions } from '../redux/channelActions';
import { bindActionCreators } from 'redux';

class ChannelsList extends Component {
  componentWillMount() {
    const { channelActions } = this.props;
    channelActions.resetSelectedChannel();
    channelActions.setChannels();
  }

  render() {
    return (
      <InternalContainer title="Channels">
        <ChannelsTable {...this.props} />
      </InternalContainer>
    );
  }
}

export default connect(
  (state) => {
    return {
      channel: state.channel,
    };
  },
  (dispatch) => {
    return {
      channelActions: bindActionCreators(channelActions, dispatch),
    };
  },
)(ChannelsList);
